const { escapeRegExp } = require('@sigma-legacy-libs/no-lodash')
const MicroCache = require('../Cache')

class StringParser {
  constructor(parsers = [], options = {}) {
    if (!Array.isArray(parsers)) {
      throw new Error('parsers must be an array!')
    }

    this.parsers = []
    this.cache = options.cache || new MicroCache()
    this.RegExp = options.RegExp || RegExp

    let allMatches = []
    parsers.forEach(parser => {
      if (typeof parser.match === 'string' && typeof parser.handler === 'function') {
        this.parsers.push({
          regexp: new this.RegExp(parser.match),
          handler: parser.handler
        })
        allMatches.push(parser.match)
      }
    })
    allMatches = allMatches.join('|')
    this.reMatchAll = new this.RegExp(`(${allMatches}|((.|\n|\r)*?(?=${allMatches}|$)))`, 'g')
  }

  _str2regexp(string = '') {
    const parts = string.match(this.reMatchAll).map(part => {
      if (!part) {
        return part
      }

      const parser = this.parsers.find(({ regexp }) => regexp.test(part))
      if (parser) {
        return parser.handler(part, part.match(parser.regexp))
      }

      return escapeRegExp(part).replace(/(\r\n|\r|\n)/g, '\\r?\\n')
    })

    return new this.RegExp('^' + parts.join('') + '$')
  }

  makeRegExp(string = '') {
    if (this.cache && typeof this.cache.once === 'function') {
      return this.cache.once(string, () => this._str2regexp(string))
    }

    return this._str2regexp(string)
  }
}

module.exports = StringParser

/*
const tags = [
  [ ['ЦИФРЫ', 'Ц', 'DIGITS', 'D'], '\\d+?'] ,
  [ ['БУКВЫ', 'Б', 'LETTERS', 'L'], '[А-яЁё\\wÀ-ÿ]+?'] ,
  [ ['БУКВЫЦИФРЫ', 'БЦ', 'LETTERSDIGITS', 'LD'], '[А-яЁё\\wÀ-ÿ\\d]+?'] ,
  [ ['БУКВЫПРОБЕЛЫ', 'БП', 'LETTERSSPACES', 'LS'], '[А-яЁё\\wÀ-ÿ\\s]+?'] ,
  [ ['БУКВЫЦИФРЫПРОБЕЛЫ', 'БЦП', 'LETTERSDIGITSSPACES', 'LDS'], '[А-яЁё\\wÀ-ÿ\\d\\s]+?'] ,
  [ ['РУССКИЕБУКВЫ', 'РБ', 'RULETTERS', 'RL'], '[А-яЁё]+?'] ,
  [ ['РУССКИЕБУКВЫЦИФРЫ', 'РБЦ', 'RULETTERSDIGITS', 'RLD'], '[А-яЁё\\d]+?'] ,
  [ ['РУССКИЕБУКВЫПРОБЕЛЫ', 'РБП', 'RULETTERSSPACES', 'RLS'], '[А-яЁё\\s]+?'] ,
  [ ['РУССКИЕБУКВЫЦИФРЫПРОБЕЛЫ', 'РБЦП', 'RULETTERSDIGITSSPACES', 'RLDS'], '[А-яЁё\\d\\s]+?' ]
].reduce((result, tag) => {
  if (!tag[1] || typeof tag[1] !== 'string') {
    return result
  }

  if (typeof tag[0] === 'string') {
    tag[0] = [ tag[0] ]
  }
  if (Array.isArray(tag[0])) {
    tag[0].forEach(t => {
      Object.assign(result, {
        [t.toLowerCase()]: tag[1]
      })
    })
  }

  return result
}, {})

const sp = new StringParser([
  {
    match: '([a-z]+://[^\\s]+)',
    handler: (part, matches) => escapeRegExp(part)
  },
  {
    match: '/(.+)/',
    handler: (part, match) => match[1]
  },
  {
    match: '#([A-zА-я_]+)#',
    handler: (part, match) => tags[match[1].toLowerCase()] || ''
  },
  {
    match: '(\\s+(\\r|\\n))',
    handler: () => '\\s*?\\n'
  }
])

const pattern = `Добрый день!
Сегодня мы рады представить вам работающие хэштеги #хэштег #hashtag #123tag
А так же работающие ссылки https://google.com/test?or=not&or2=yes#h1 okay?
So suck a dick, dumbshits! #БУКВЫПРОБЕЛЫ# /any\\/\\/regex.*? here/`
const text = `Добрый день!
Сегодня мы рады представить вам работающие хэштеги #хэштег #hashtag #123tag
А так же работающие ссылки https://google.com/test?or=not&or2=yes#h1 okay?
So suck a dick, dumbshits! какие угодно блин bukwy vse ravno rabotaet any//regexfucksake here`
const re = sp.makeRegExp(pattern)
console.log(re.test(text))
console.log(re)
 */
